import { react } from "../../../omnia"
import { PlanApi } from "../../api"
import { PlanAction } from "../../reducer"

export function resetPlan(api: PlanApi, dispatch: React.Dispatch<PlanAction>) {

    const { year } = api

    const content = <>

        <p>This will delete all observations and actions, and reset all analyses, for the current holding in year {year}.</p>

        <p>Click 'Reset' to proceeed.</p>

        <p style={{ margin: "1.5em 0 1em 0", color: "#F44336", textAlign: "center" }}>
            <i className="fas fa-exclamation-triangle"></i>
            <strong>Warning</strong>: this operation is irreversible.
        </p>


    </>

    const title = `Reset year ${year}`

    react.showDeleteCancel(content, title, "Reset").then(ok => {

        if (ok) {

            return api
                .resetCurrentYear()
                .then(data => dispatch({ type: "load", data }))

        }

    })


}
